import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import promiseMiddleware from 'redux-promise';
import ActiveSettings from './ActiveSettings';
import * as Properties from './Properties';
import * as Sensors from './Sensors';
import * as Fields from './Fields';
import * as Devices from './Devices';
import * as Organizations from './Organizations';
import * as Leaflet from './Leaflet';
import * as Telemetry from './Telemetry';
import * as Events from './Events';

import * as Notifications from './Notifications';
import * as HealthIntervals from './HealthIntervals';
import * as Users from './Users';

const loadState = () => {
  const serializedState = localStorage.getItem('state'); // eslint-disable-line
  try {
    if (serializedState === null) {
      return {};
    }
    return {}; // JSON.parse(serializedState);
  } catch (err) {
    return {};
  }
};

const saveState = () => {
  try {
    // const serializedState = JSON.stringify({
    //   properties: state.properties,
    //   activeSettings: state.activeSettings,
    //   map: state.map,
    //   // getAllTelemetry: state.telemetry,
    // });
    //localStorage.setItem('state', serializedState); // eslint-disable-line
  } catch (err) {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.log('Could not save state', err);
    } // eslint-disable-line
  }
};

const persistedState = loadState();

const reducers = {
  properties: Properties.reducer,
  organizations: Organizations.reducer,
  map: Leaflet.reducer,
  activeSettings: ActiveSettings.reducer,
  telemetry: Telemetry.reducer,
  sensors: Sensors.reducer,
  events: Events.reducer,
  notifications: Notifications.reducer,
  healthIntervals: HealthIntervals.reducer,
  users: Users.reducer,
  fields: Fields.reducer,
  devices: Devices.reducer,
};

const appReducer = combineReducers(reducers);

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_USER' || action.type === 'REFRESH') {
    // This eventually should be stored to the USER account
    // activeSettings: state.activeSettings,
    return appReducer({}, action);
  }
  return appReducer(state, action);
};

const logger = createLogger({
  collapsed: (getState, action, logEntry) => !logEntry.error, //this could just be true and it would collape everything. This collapeses everything but the errors.
  duration: true, //shows how long a call took
  diff: true, //shows the diff between the prev state and current state
  //predicate: (getState, action) =>!action.type.includes('REQUEST_TELEMETRY') && !action.type.includes('RECEIVE_TELEMETRY'), //an example for how to filter out what the redux-logger shows
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line

const middleware = composeEnhancers(applyMiddleware(thunk, promiseMiddleware, logger));

const store = createStore(rootReducer, persistedState, middleware);

// eslint-disable-next-line no-unused-vars
export const initializeAPIs = async (token) => {
  // eslint-disable-line
  // if (!token) return;
  // await SwaggerAPI.setupAPI(CognitoAPI.refreshSession, CognitoAPI.logout, store.dispatch);
  // await SwaggerAPI.initialize(token, false);
};

// if (persistedState && persistedState.cognito && persistedState.cognito.accessToken) {
initializeAPIs(); // persistedState.cognito.accessToken);
// }

store.subscribe(() => {
  saveState(store.getState());
});

export const getState = () => store.getState();

export default store;
